/**
 * @file Advert 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-20
 */

import React, {useEffect, useState} from 'react';

import './index.less';

function Advert({stockInfo}) {
    const {code, exchange, currentPrice, priceUpAndDown, priceUpAndDownPercent, volume, marketCapital} = stockInfo;

    return (
        <div className="advert-container">
            <div className="advert-content">
                <div className="advert-title">
                    <span>
                        Make Learning Better
                    </span>
                </div>


                <div className="advert-stock-container">
                    <div className="advert-exchange">
                        {exchange}
                        {' '}
                        :
                        {' '}
                        {code}
                    </div>
                    <div className="advert-stock-price">
                        $
                        {' '}
                        {currentPrice}
                    </div>

                    <div className="advert-stock-range">
                        $
                        {' '}
                        {priceUpAndDown}
                        {' '}
                        (
                        {(priceUpAndDownPercent < 0 ? '' : '+') + priceUpAndDownPercent}
                        %)
                    </div>
                    <div className="advert-stock-volume">
                        Volume :
                        {' '}
                        {volume}
                    </div>
                    <div className="advert-stock-cap">
                        Market Cap : $
                        {' '}
                        {marketCapital}
                    </div>

                    <div className="advert-prompt">
                        Currency in USD. Quote data delayed by at least 15 minutes
                    </div>
                </div>

            </div>


        </div>
    );
}

export default Advert;
